import React, { useState } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import InputFields from "../../utils/UserInput";
import { Modal, Select, Typography, message } from "antd";
import ImageUpload from "../UsersPage/UploadImage";
import PermissionTable from "./ModularRights";
import { MultiPostRequest, postRequest } from "../../utils/APICall";
import moment from "moment";
import { useSelector } from "react-redux";

const EmpForm = ({ visible, onClose, skillData, desigOpt, deptOpt }) => {
  const [selectDept, setSelectDept] = useState(null);
  const [selectSkillID, setSelectSkillID] = useState([]);
  const [modules, setModules] = useState([]);
  const { users } = useSelector((state) => state.user || {})

  const validationSchema = Yup.object().shape({
    firstName: Yup.string().required("First name is required"),
    lastName: Yup.string().required("Last name is required"),
    email: Yup.string().email("Invalid email").required("Email is required"),
    designation: Yup.string().required("Designation is required"),
    department: Yup.string().required("Department is required"),
    joinDate: Yup.string().required("Join date is required"),
    phone: Yup.string().required("Phone is required"),
  });

  const initialValues = {
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    emergencyNum: "",
    joinDate: "",
    leavingDate: "",
    qualification: "",
    major: "",
    certificate: "",
    designation: "",
    department: "",
    accTitle: "",
    bankName: "",
    bankBranch: "",
    accNo: "",
    IBNNo: "",
  };

  const DesigOpt = desigOpt?.map((desig) => ({
    value: String(desig.CODE),
    label: desig.TITLE,
  })) || [];

  const DeptOpt = deptOpt?.map((dept) => ({
    value: dept.CODE,
    label: dept.TITLE,
  })) || [];

  const optionQua =
    skillData?.qualification?.map((skill) => ({
      value: skill.ID,
      label: skill.TITLE,
    })) || [];

  const optionSkill =
    skillData?.skills?.map((skill) => ({
      value: skill.ID,
      label: skill.TITLE,
    })) || [];



  const handleChangeSkills = (value) => {
    setSelectSkillID(value);
  };

  const [dataFiles, setDataFiles] = useState([]);
  const [images, setImages] = useState([]);

  const handleModulesChange = (updatedModules) => {
    setModules(updatedModules);
  };

  const handleSubmit = async (values, { resetForm, setSubmitting }) => {
    const formData = new FormData();
    for (const key in values) {
      formData.append(key, values[key]);
    }
    formData.append("skills", JSON.stringify(selectSkillID));
    formData.append("createdby", `${users?.FIRSTNAME} ${users?.LASTNAME}| ${moment(Date.now()).format("DD-MM-YYYY HH:mm")}`);
    if (dataFiles[0]) {
      formData.append("document", dataFiles[0]);
    }
    // console.log("Submitting employee data:", Object.fromEntries(formData));
    try {
      //  Add employee
      const empResponse = await MultiPostRequest("addemp", formData);
      // console.log("addemp response:", empResponse);

      if (!empResponse.status) {
        message.error(empResponse?.details || "Failed to add employee");
        setSubmitting(false);
        return;
      }

      if (empResponse.status) {
      message.success("Employee added successfully");
      resetForm();
      setModules([]);
      setSelectDept(null);
      setSelectSkillID([]);
      setDataFiles([]);
      setImages([]);

      onClose();
      window.location.reload()
      }

      // Success: Show message and reset form
    } catch (error) {
      console.error("Submission error:", error);
      message.error(`An error occurred: ${error.message}`);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal
      title={<div className="text-xl font-bold text-center">Add Employee</div>}
      open={visible}
      onCancel={onClose}
      footer={null}
    >
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ isSubmitting }) => (
          <Form>
            <span className="flex justify-center items-center py-4">
              <ImageUpload
                setData={setDataFiles}
                images={images}
                setImages={setImages}
              />
            </span>
            <span className="grid grid-cols-1 gap-2 md:grid-cols-2">
              <InputFields
                label="First Name"
                type="text"
                placeholder="Enter your firstName"
                name="firstName"
              />
              <InputFields
                label="Last Name"
                type="text"
                placeholder="Enter lastName"
                name="lastName"
              />
              <InputFields
                label="Email"
                type="email"
                name="email"
                placeholder="Enter Email"
              />
              <InputFields
                label="Joining Date"
                type="date"
                name="joinDate"
                placeholder="Enter Joining Date"
              />
              <InputFields
                label="Leaving Date*"
                type="date"
                name="leavingDate"
                placeholder="Enter Leaving Date"
              />
              <InputFields
                label="Qualification*"
                type="select"
                name="qualification"
                placeholder="Enter Qualification (optional)*"
                options={optionQua}
              />
              <InputFields
                label="Major"
                type="text"
                placeholder="Enter Major"
                name="major"
              />
              <InputFields
                label="Certificate*"
                type="text"
                placeholder="Enter certificate (optional)*"
                name="certificate"
              />
              <InputFields
                label="Phone"
                type="number"
                name="phone"
                placeholder="Enter Phone"
              />
              <InputFields
                label="Emergency Number"
                type="number"
                name="emergencyNum"
                placeholder="Enter Emergency / Secondary Number"
              />
              <InputFields
                label="Department"
                type="select"
                name="department"
                placeholder="Enter Department"
                options={DeptOpt}
              />
              <InputFields
                label="Designation"
                type="select"
                name="designation"
                placeholder="Enter Designation"
                options={DesigOpt}
              />
              <span className="w-full">
                <Typography.Text strong>Select Skills</Typography.Text>
                <Select
                  mode="multiple"
                  style={{ width: "100%" }}
                  placeholder="Add Skills"
                  onChange={handleChangeSkills}
                  options={optionSkill}
                  optionFilterProp="label"   
                  // filterOption={(input, option) =>
                  //   (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                  // }
                />
              </span>
              <InputFields
                label="Account Title"
                type="text"
                name="accTitle"
                placeholder="Enter Account Title"
              />
              <InputFields
                label="Bank Name"
                type="text"
                placeholder="Enter Bank Name"
                name="bankName"
              />
              <InputFields
                label="Bank Branch"
                type="text"
                placeholder="Enter Bank Branch"
                name="bankBranch"
              />
              <InputFields
                label="Account No"
                type="text"
                placeholder="Enter Account No"
                name="accNo"
              />
              <InputFields
                label="IBN No"
                type="text"
                placeholder="Enter IBN No"
                name="IBNNo"
              />
            </span>

            {/* <div className="block my-3">
              <PermissionTable onModulesChange={handleModulesChange} />
            </div> */}
            <button
              type="submit"
              disabled={isSubmitting}
              className={isSubmitting ? "cursor-not-allowed mt-6 flex justify-center items-center mx-auto w-full max-h-10 bg-blue-500 text-white px-4 py-2 rounded" : "mt-6 flex justify-center items-center mx-auto w-full max-h-10 bg-blue-500 text-white px-4 py-2 rounded"}
            >
              {isSubmitting ? "Loading..." : "Submit"}
            </button>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default EmpForm;